import type { BadgeProps } from '@/shared/components/ui/badge';

/**
 * 거래 상태 statusView ↔ 화면 규칙 (docs/api/accounts.md 「거래 상태 statusView ↔ 화면」)
 * 좌측 목록 그룹 · 배지 색 · 처방 등록 가능 여부를 한곳에서 정한다.
 */
export type RelationshipGroup = 'applying' | 'ongoing' | 'closed';

/** 처방 등록 가능 — 거래처 승인(승인 7일 이내)도 거래중으로 본다 */
const ONGOING = ['거래 중', '거래처 승인'];
const CLOSED = ['거래 종료', '신청 거절'];

/** 거래 신청 · 이관 확인 중 · 확인 중은 신청 그룹. 모르는 값도 등록을 막는 쪽(신청)으로 둔다 */
export const getRelationshipGroup = (statusView: string): RelationshipGroup => {
  if (ONGOING.includes(statusView)) return 'ongoing';
  if (CLOSED.includes(statusView)) return 'closed';
  return 'applying';
};

/** 좌측 목록 탭 이름 (Figma Tab 485:4661) */
export const RELATIONSHIP_GROUP_LABEL: Record<RelationshipGroup, string> = {
  applying: '거래 신청',
  ongoing: '거래 중',
  closed: '종료·거절',
};

/** v1.0 배지 모양 (Badge & Chip) — state · emphasis */
export type StatusBadgeStyle = Pick<BadgeProps, 'state' | 'emphasis'>;

/**
 * 거래처 대표 상태 배지 (Figma 거래처_리스트 886:12817 · 886:12835 · 905:14012 · 905:14061)
 * - 신청 그룹(거래 신청 · 확인 중 · 이관 확인 중): Warning strong (노랑)
 * - 거래 종료: Disabled strong (회색) · 신청 거절: Error strong (빨강)
 * - 거래 중 · 거래처 승인: Success weak — 목록에는 보이지 않고 상세 헤더에서만 쓴다
 */
export const getStatusBadgeStyle = (statusView: string): StatusBadgeStyle => {
  switch (statusView) {
    case '거래 중':
    case '거래처 승인':
      return { state: 'success', emphasis: 'weak' };
    case '신청 거절':
      return { state: 'error', emphasis: 'strong' };
    case '거래 종료':
      return { state: 'disabled', emphasis: 'strong' };
    default:
      return { state: 'warning', emphasis: 'strong' };
  }
};

/** 병원급은 의약품, 의원급은 제약사 단위로 거래를 본다 (M-05) */
export const isHospitalType = (clinicTypeLabel?: string | null) =>
  clinicTypeLabel === '병원급';
